<button 
  [type]="type" 
  class="button-primary" 
  [disabled]="disabled"
  [matTooltip]="tooltipText ? ('TOOLTIPS.' + tooltipText | translate) : ''"
  [matTooltipPosition]="tooltipPosition"
  matTooltipClass="label-tooltip"
  *ngIf="isPrimaryButton; else buttonSecondary">
  <atom-icon *ngIf="displayIcon" [iconClass]="iconClass"></atom-icon>
  {{ 'BUTTONS.' + label | translate }}
</button>

<ng-template #buttonSecondary>
  <button 
    [type]="type" 
    class="button-secondary" 
    [disabled]="disabled"
    [matTooltip]="tooltipText ? ('TOOLTIPS.' + tooltipText | translate) : ''"
    [matTooltipPosition]="tooltipPosition"
    matTooltipClass="label-tooltip">
    <atom-icon *ngIf="displayIcon" [iconClass]="iconClass"></atom-icon>
    {{ 'BUTTONS.' + label | translate }}
  </button>
</ng-template>